import { authorConfig } from "@cirrus/app-author/config"
import { deliveryConfig } from "@cirrus/app-delivery/config"
import { proctorConfig } from "@cirrus/app-proctor/config"

export const getSubAppConfig = (key = window.subAppConfigKey) => {
  switch (key) {
    case "author":
      return authorConfig
    case "delivery":
      return deliveryConfig
    case "proctor":
      return proctorConfig
    default:
      return {}
  }
}
